import $ from "jquery"
import { trace } from "./../shared/helpers.js"
import AjaxLoader from "./../shared/AjaxLoader";

const UFilters = {
  selector : '#u-filters',
  selectorData : '#u-filters-swap',


  getSelectedFilterIDs() {
    let ids = [];
    this.$wrapper.find("input[type='checkbox']").each( (index,el)=> {      
      if ($(el).prop("checked")) {
        ids.push($(el).data("id"));
      }
    });
    return ids;
  },

  // add filter params to URL
  urlFilterParams(url) {
    let params = "";
    let selectedIds = this.getSelectedFilterIDs();
    selectedIds.forEach((id)=> {
      params += "," + id;
    });
    return url.replace(".ajax", params + ".ajax");
  },


  updateFilters() {
    let url = this.$wrapper.find('div[data-url]').data("url");
    url = this.urlFilterParams(url);
    AjaxLoader.openURL(url);
  },

  removeFilters() {
    let ids = this.getSelectedFilterIDs();
    if (!ids.length) {      
      return false;
    }
    this.$wrapper.find("input[type='checkbox']").each( (index,el)=> {
       $(el).prop("checked", false);
    });
    this.updateFilters();
  },


  initFilters() {    
    $('body').on("change", this.selector + " input[type='checkbox']", (e)=> {
      this.updateFilters();
    });
    // remove all fiters on hide (collapse) filters
    $('body').on("hidden.bs.collapse", "#filters-collapse", (e)=> {
      this.removeFilters();
    });
  },

  init() {
    if ($(this.selector).length) {
      this.$wrapper = $(this.selector);      
      this.initFilters();
    }
  }

}

export default UFilters;